// https://github.com/drwpow/openapi-typescript/tree/a18b8a6a50c640a55f5802ea6189b4c4cd1c9d09#using-in-typescript

// ⚠️ IF THOSE IMPORTS FAIL, RUN `make models`!
import type { components } from "./generated-api-schema"; // see makefile: `$ make models`
import openapiJSON from "./generated-api-schema.json"; // see makefile: `$ make models`
export { AllMyStorageApiClient } from "./generated-api-schema/AllMyStorageApiClient";

import type { CustomField } from "./custom-fields";
import type { ObjectSchemaOut } from "./custom-schemas";

// Object stuff
export type ApiObject = components["schemas"]["ObjectOut"];
// The generated `type_config` is a loose union per field variant, so custom_fields and schemas use the hand-written
// discriminated types (see `custom-fields.ts`) instead of whatever the generated schema has.
export type ApiObjectWithReferences = Omit<components["schemas"]["ObjectWithReferences"], "custom_fields" | "schemas"> & {
  custom_fields?: CustomField[];
  schemas?: ObjectSchemaOut[];
};
export type ApiBarcode = components["schemas"]["BarcodeOut"];
export type ApiObjectType = number;

export type BarcodeContainment = components["schemas"]["BarcodeContainment"];
export type BarcodeContainmentResult = components["schemas"]["BarcodeContainmentResult"];
export type PhotoToInsert = components["schemas"]["PhotoToInsert"];
export type BarcodeToInsert = components["schemas"]["BarcodeCreate"];

// Icon stuff
export type SVG = components["schemas"]["SVG"];
export type IconSet = components["schemas"]["IconSet"];
export type IconName = string;
export type IconStyle = string;

export type FontAwesomeIcon = {
  type: IconSet;
  name: IconName;
  style: IconStyle;
};

// Models for api routes
export const ObjectCreateSchema = openapiJSON.components.schemas.ObjectCreate;
export const ObjectPatchSchema = openapiJSON.components.schemas.ObjectPatch;
export const MoveObjectSchema = openapiJSON.components.schemas.MoveObject;
